import {
  mdiArchiveOutline,
  mdiHomeOutline,
  mdiPoll,
  mdiTruckOutline,
  mdiWalletOutline
} from "@mdi/js";
import { routes } from "./routes";

export const AVAILABLE_NAV_LIST_BY_ACCOUNT_TYPE = {
  default: ["haulpay", "trucks", "home", "loads", "rate-trend"],
  shipper: ["home", "loads", "rate-trend"],
  dispatcher: ["trucks", "home", "loads", "rate-trend"]
};

export const MOBILE_NAV_ITEMS = [
  {
    icon: mdiWalletOutline,
    link: routes.HAULPAY,
    title: "haulpay"
  },
  {
    icon: mdiTruckOutline,
    link: routes.TRUCKS,
    title: "trucks"
  },
  {
    icon: mdiHomeOutline,
    link: routes.HOME,
    title: "home"
  },
  {
    icon: mdiArchiveOutline,
    link: routes.LOADS,
    title: "loads"
  },
  {
    icon: mdiPoll,
    link: routes.RATE_TREND,
    title: "rate-trend"
  }
];
